import React from 'react'
import { StylizedCalendarWrapper } from './styles'
import { DatePickerRange, PopoverFilter } from '~/components/shared'

interface CalendarFilterProps {
  filterPeriod: Date[]
  handleFilterByDate: (rangeDates: Date[]) => void
}

export const CalendarFilter = ({ filterPeriod, handleFilterByDate }: CalendarFilterProps): JSX.Element => {
  return (
    <PopoverFilter
      iconName="dateRange"
      svgFilled
      tooltipDescription="Selecionar data"
      active={filterPeriod.length > 0}
      position="right"
    >
      <StylizedCalendarWrapper>
        <DatePickerRange
          setPeriod={handleFilterByDate}
          buttonsDefinedPeriods={[
            { label: '1 mês', returnInMonths: 0.2 },
            { label: '3 meses', returnInMonths: 3 },
            { label: '6 meses', returnInMonths: 6 },
            { label: '1 ano', returnInMonths: 12 }
          ]}
        />
      </StylizedCalendarWrapper>
    </PopoverFilter>
  )
}
